import { observable, makeObservable } from 'mobx';

import { ICategoryInfo } from '@gem/models/commonModel';

import { NewsType, INewsItem } from 'APP/model/catalog/catalogModel.types';

import { NewsItem } from './NewsItem';

export class Categories extends NewsItem {
  @observable categories: ICategoryInfo[];

  constructor(data: INewsItem) {
    super(NewsType.Categories);

    makeObservable(this);

    this.categories = Array.isArray(data?.categories) ? data.categories : [];
  }
}
